module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/consultation/consultation-edit/consultation-edit.component.scss
// module id = ./src/app/consultation/consultation-edit/consultation-edit.component.scss
// module chunks = main